<div class="guide-section">
  <div class="row">
    <div class="guide-section__title">
      Shipping rules
      @if (showExpansionGuide === 'conditions' || exp1.expanded == true) {
        <div class="guide-section__subtext">Control when this option appears at checkout</div>
      }
    </div>
    <div class="content__conditions">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="onOpenExpansion('conditions')"
          (closed)="onCloseExpansion()"
          [expanded]="isExpandedNeeded('conditions')"
          #exp1="matExpansionPanel">
          <mat-expansion-panel-header>
            <mat-panel-description>
              <div class="content__conditions__title" [ngClass]="exp1.expanded == true ? 'margin-title-exp' : ''">
                Shipping rules
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formGroup">
            @if (!hideInstructionText) {
              <div>
                <span class="content__conditions__text">Show this option only if these rules match:</span>
              </div>
            }
            @for (conditionsGroup of conditionsField.controls; track conditionsGroup; let conditionsIndex = $index) {
              @if (conditionsIndex > 0) {
                <div class="tag-wrapper">
                  <div class="or-tag">Or</div>
                </div>
              }
              <div [formGroup]="conditionsGroup" class="conditions-group">
                <div class="conditions">
                  @for (
                    conditionGroup of getConditionsControls(conditionsIndex);
                    track conditionGroup;
                    let conditionIndex = $index
                  ) {
                    <div [formGroup]="conditionGroup" class="condition-group-wrapper">
                      <div class="condition-wrapper flex-row">
                        <div class="list-wrapper entity-list">
                          <pdq-dropdown
                            class="subject"
                            variant="static"
                            [options]="filterOptions | sortByLabel"
                            (onChange)="
                              entityChanged($event, conditionGroup, conditionsIndex, conditionIndex, conditionsGroup)
                            "
                            width="auto"
                            placeholder="Select"
                            [defaultOption]="
                              conditionGroup.controls.name.value
                                ? {
                                    label: conditionGroup.controls.displayName.value,
                                    value: conditionGroup.controls.name.value,
                                  }
                                : null
                            "
                            [staticListMaxHeight]="dropdownMaxHeight"
                            [useOverlay]="useDropdownOverlay"
                            [dirty]="!!conditionGroup.controls.name.value">
                          </pdq-dropdown>
                        </div>
                        @if (conditionGroup.controls.name.value) {
                          <div class="list-wrapper condition-list">
                            <pdq-dropdown
                              class="condition"
                              variant="static"
                              [options]="
                                conditionGroup.controls.name.value
                                  ? filterConditionBySelectedFilter(conditionGroup.controls.name.value)
                                  : []
                              "
                              width="auto"
                              (onChange)="
                                conditionChanged(
                                  $event,
                                  conditionGroup,
                                  conditionsIndex,
                                  conditionIndex,
                                  conditionsGroup
                                )
                              "
                              placeholder="Select"
                              [defaultOption]="
                                conditionGroup.controls.condition.value
                                  ? {
                                      label: getConditionLabelByValue(conditionGroup.controls.condition.value),
                                      value: conditionGroup.controls.condition.value,
                                    }
                                  : null
                              "
                              [staticListMaxHeight]="dropdownMaxHeight"
                              [useOverlay]="useDropdownOverlay"
                              [dirty]="!!conditionGroup.controls.condition.value">
                            </pdq-dropdown>
                          </div>
                          @if (
                            selectedFilterOptions[conditionGroup.controls.name.value] &&
                            !conditionGroup.controls.condition.value?.includes('contains') &&
                            !conditionGroup.controls.condition.value?.includes('amount')
                          ) {
                            <div class="condition-dropdown">
                              <pdq-dropdown
                                formControlName="value1"
                                [options]="getConditionFilterOptions(conditionGroup.controls.name.value)"
                                [placeholder]="'Select option'"
                                [defaultOption]="
                                  conditionGroup.controls.value1.value
                                    ? {
                                        label: getConditionFilterOptionLabel(
                                          conditionGroup.controls.name.value,
                                          conditionGroup.controls.value1.value
                                        ),
                                        value: conditionGroup.controls.value1.value,
                                      }
                                    : null
                                "
                                [staticListMaxHeight]="dropdownMaxHeight"
                                [useOverlay]="useDropdownOverlay"
                                [dirty]="!!conditionGroup.controls.value1.value">
                              </pdq-dropdown>
                            </div>
                          } @else {
                            @if (
                              conditionGroup.controls.condition.value === 'contains' ||
                              conditionGroup.controls.condition.value === 'not_contains' ||
                              conditionGroup.controls.condition.value === 'does_not_equal'
                            ) {
                              <div>
                                <input
                                  class="pdq-mat-input"
                                  style="margin-top: 0"
                                  matInput
                                  #conditionSectionAutocomplete
                                  formControlName="value1"
                                  type="text"
                                  [placeholder]="
                                    conditionGroup.controls.name.value?.includes('metafield')
                                      ? 'namespace.key:value'
                                      : 'Type here'
                                  "
                                  [ngClass]="'simple-placeholder'" />
                              </div>
                            } @else {
                              @if (conditionGroup.controls.name.value?.includes('metafield')) {
                                <div>
                                  <input
                                    class="pdq-mat-input"
                                    style="margin-top: 0"
                                    matInput
                                    formControlName="value1"
                                    type="text"
                                    placeholder="namespace.key:value"
                                    [ngClass]="'simple-placeholder'" />
                                </div>
                              } @else if (conditionGroup.controls.name.value === 'cartAttribute') {
                                <div>
                                  <input
                                    class="pdq-mat-input"
                                    style="margin-top: 0"
                                    matInput
                                    formControlName="value1"
                                    type="text"
                                    placeholder="key:value"
                                    [ngClass]="'simple-placeholder'" />
                                </div>
                              } @else if (conditionGroup.controls.name.value === 'customerOrderCount') {
                                <div class="customer-order-count">
                                  <pdq-input-arrows
                                    formControlName="value1"
                                    placeholder="Select option"
                                    min="0"
                                    precision="0"
                                    [dirty]="!!conditionGroup.controls.value1.value"></pdq-input-arrows>
                                </div>
                              } @else if (isNotNumericFilterSelected(conditionGroup.controls.name.value)) {
                                <div class="content__conditions__input">
                                  <mat-label style="display: none"></mat-label>
                                  <input
                                    class="pdq-mat-input"
                                    matInput
                                    #conditionSectionAutocomplete
                                    formControlName="value1"
                                    type="text"
                                    placeholder="Type here"
                                    [matAutocomplete]="auto"
                                    [ngClass]="'simple-placeholder'" />
                                  <mat-autocomplete
                                    #auto="matAutocomplete"
                                    class="pdq-mat-autocomplete-panel condition-autocomplete-panel">
                                    @if (autoCompleteCollections[conditionGroup.controls.name.value]?.isLoading) {
                                      <mat-option class="is-loading">
                                        <span style="justify-content: center; display: flex">
                                          <mat-spinner diameter="25" [color]="'#22214C'"></mat-spinner>
                                        </span>
                                      </mat-option>
                                    }
                                    @if (
                                      autoCompleteCollections[conditionGroup.controls.name.value]?.list?.length === 0 &&
                                      !autoCompleteCollections[conditionGroup.controls.name.value]?.isLoading
                                    ) {
                                      <mat-option>No Results Found</mat-option>
                                    }
                                    @if (!autoCompleteCollections[conditionGroup.controls.name.value]?.isLoading) {
                                      @for (
                                        list of autoCompleteCollections[conditionGroup.controls.name.value]?.list;
                                        track list
                                      ) {
                                        <mat-option [value]="list">
                                          <span>{{ list }}</span>
                                        </mat-option>
                                      }
                                    }
                                  </mat-autocomplete>
                                </div>
                              } @else if (
                                conditionGroup.controls.name.value === 'cartValue' ||
                                conditionGroup.controls.name.value === 'customerSpend' ||
                                conditionGroup.controls.name.value === 'grossMargin'
                              ) {
                                <pdq-input-arrows
                                  class="cart_value"
                                  min="0"
                                  widthSize="large"
                                  formControlName="value1"
                                  [symbol]="shippingMethodCurrency | async | currencySign"
                                  precision="2"
                                  [dirty]="!!conditionGroup.controls.value1.value">
                                </pdq-input-arrows>
                              } @else if (conditionGroup.controls.name.value === 'coupons') {
                                <pdq-input-arrows
                                  class="cart_value"
                                  min="0"
                                  widthSize="large"
                                  formControlName="value1"
                                  precision="2"
                                  [dirty]="!!conditionGroup.controls.value1.value">
                                </pdq-input-arrows>
                                <pdq-dropdown
                                  formControlName="value2"
                                  [options]="currencyOrPercentOptions"
                                  placeholder="Select option"
                                  [staticListMaxHeight]="dropdownMaxHeight"
                                  [useOverlay]="useDropdownOverlay"
                                  [dirty]="!!conditionGroup.controls.value2.value"></pdq-dropdown>
                              } @else if (conditionGroup.controls.name.value == 'weight') {
                                <div class="weight-input">
                                  <input
                                    class="pdq-mat-input"
                                    matInput
                                    formControlName="value1"
                                    type="number"
                                    min="0"
                                    placeholder="Enter number here" />
                                </div>
                                <div class="content__conditions__select-position-condition">
                                  <div class="weightUnit">
                                    <div class="custom-select-panel rule-match-select-width">
                                      <pdq-dropdown
                                        formControlName="weightUnit"
                                        [options]="weightUnitsOptions"
                                        [staticListMaxHeight]="dropdownMaxHeight"
                                        [useOverlay]="useDropdownOverlay"
                                        [dirty]="!!conditionGroup.controls.weightUnit.value"></pdq-dropdown>
                                    </div>
                                  </div>
                                </div>
                              } @else {
                                <div class="weight-input">
                                  <input
                                    class="pdq-mat-input"
                                    matInput
                                    formControlName="value1"
                                    type="number"
                                    min="0"
                                    placeholder="Enter number here" />
                                </div>
                              }
                            }
                          }
                          @if (conditionGroup.controls.name.value === 'sku') {
                            <div class="sku_quantity">
                              quantity is
                              <pdq-input-arrows
                                min="0"
                                widthSize="large"
                                formControlName="value2"
                                placeholder="no limit"
                                [dirty]="!!conditionGroup.controls.value2.value"></pdq-input-arrows>
                            </div>
                          }
                          @if (conditionGroup.controls.name.value === 'customerOrderCount') {
                            <div class="customer-order-count">
                              <pdq-dropdown
                                formControlName="value2"
                                [options]="customerOrderCountTimePeriodOptions"
                                placeholder="Select option"
                                [staticListMaxHeight]="dropdownMaxHeight"
                                [useOverlay]="useDropdownOverlay"
                                [dirty]="!!conditionGroup.controls.value2.value"></pdq-dropdown>

                              @if (conditionGroup.controls.value2.value === 'last_days') {
                                <div class="days-input-container">
                                  <pdq-input-arrows
                                    class="calendar_days"
                                    min="1"
                                    widthSize="medium"
                                    formControlName="optionalValue"
                                    precision="0"
                                    max="365"
                                    [dirty]="!!conditionGroup.controls.optionalValue.value">
                                  </pdq-input-arrows>
                                  <span class="days-label">calendar days</span>
                                </div>
                              }
                            </div>
                          }
                          @if (conditionGroup.controls.name.value === 'grossMargin') {
                            <div class="gross-margin">
                              <pdq-dropdown
                                formControlName="optionalValue"
                                [options]="grossMarginUnitOptions"
                                placeholder="Select option"
                                [staticListMaxHeight]="dropdownMaxHeight"
                                [useOverlay]="useDropdownOverlay"
                                [dirty]="!!conditionGroup.controls.optionalValue.value"></pdq-dropdown>
                            </div>
                          } @else if (conditionGroup.controls.name.value === 'cartValue') {
                            <div class="cart-value-discount-basis">
                              <pdq-dropdown
                                formControlName="optionalValue"
                                [options]="cartValueDiscountBasisOptions"
                                [placeholder]="defaultCartValueBasisLabel"
                                [staticListMaxHeight]="dropdownMaxHeight"
                                [useOverlay]="useDropdownOverlay"
                                [dirty]="!!conditionGroup.controls.optionalValue.value"></pdq-dropdown>
                            </div>
                          } @else if (conditionGroup.controls.name.value === 'shopify_tags') {
                            quantity
                            <div class="condition-dropdown" style="margin-left: 0">
                              <pdq-dropdown
                                formControlName="value2"
                                [options]="productTagsQuantityOptions"
                                [placeholder]="'Select'"
                                [staticListMaxHeight]="dropdownMaxHeight"
                                [useOverlay]="useDropdownOverlay"
                                [dirty]="!!conditionGroup.controls.value2.value">
                              </pdq-dropdown>
                            </div>
                            <pdq-input-arrows
                              class="cart_value"
                              min="0"
                              widthSize="large"
                              formControlName="optionalValue"
                              [dirty]="!!conditionGroup.controls.optionalValue.value"
                              precision="2">
                            </pdq-input-arrows>
                          }
                        }
                        <div class="row right-icons">
                          @if (conditionIndex >= 24 || conditionGroup.invalid || hasAnyInvalidCondition()) {
                            <pdq-icon
                              size="small"
                              class="add-condition-new"
                              color="#C7CDD6"
                              icon="circle-plus"
                              (click)="addCondition(conditionsIndex)">
                            </pdq-icon>
                          } @else {
                            <pdq-icon
                              size="small"
                              class="add-condition-new"
                              icon="circle-plus"
                              (click)="addCondition(conditionsIndex)">
                            </pdq-icon>
                          }
                          <pdq-icon
                            size="small"
                            class="add-condition-new"
                            icon="trash"
                            color="red"
                            (click)="deleteCondition(conditionsIndex, conditionIndex)">
                          </pdq-icon>
                        </div>
                      </div>

                      <!-- <div>
				  <mat-error
					class="mat-error-text"
						*ngIf="
						  showFormErrors &&
						  (!conditionGroup.get('name').valid ||
							!conditionGroup.get('condition').valid ||
							!conditionGroup.get('value1').valid)
						">
					{{ getConditionError(conditionGroup, conditionIndex) }}
				  </mat-error>
				</div> -->
                    </div>
                  }
                </div>
              </div>
            }
            @if (!hideAddGroupButton) {
              <div class="add-conditions">
                <pdq-button
                  plain="true"
                  size="large"
                  [disabled]="false"
                  icon="Plus"
                  variant="ghost-light"
                  [loading]="false"
                  (onClick)="addConditions()">
                </pdq-button>
                <pdq-button
                  plain="true"
                  size="small"
                  label="Add rule group"
                  [disabled]="false"
                  variant="ghost-light"
                  [loading]="false"
                  (onClick)="addConditions()">
                </pdq-button>
              </div>
            }
            @if (showConditionsErrorMsg) {
              <div style="font-size: 13px; color: red; margin-left: 10px">
                {{ showConditionsErrorMsg }}
              </div>
            }
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
